import { type IColumn, Avatar, Typography, Button, Box } from 'shared/ui'
import { getLabelAsNumberInternationalFormat, formatPhoneNumberToInternational } from 'shared/lib'
import { type RowContactDuplicate } from 'entities/Contacts/model/Table/RowContactDuplicate'
import { type ContactsDuplicateTableStore } from 'pages/contacts/pages/cleanup/ui/ContactsDuplicateTable'
import styles from './styles.module.scss'

const ContactRowCell = ({ row }: { row: RowContactDuplicate }) => {
  const colors = ['#6372A5', '#1D95F2', '#10D0AD', '#E13466', '#FFC422', '#FF9423', '#A233E1']
  const color = colors[row.id % colors.length]

  const number = formatPhoneNumberToInternational(row.origin.formatted_number)

  const avatarInfo = {
    firstName: row.origin.number || '#',
    lastName: '',
    color,
    number: number,
    image: undefined,
  }

  return (
    <Box
      sx={{
        alignItems: 'center',
        height: '32px',
      }}
      gap={1}
      display='flex'
    >
      <Avatar info={avatarInfo} size={24} />
      <Typography ellipsis variant={'body-md-regular'} tag={'div'} ariaLabel={'formatted_number'}>
        {getLabelAsNumberInternationalFormat(number)}
      </Typography>
    </Box>
  )
}

const DuplicateRowCell = ({ row }: { row: RowContactDuplicate }) => {
  return <div className={styles.duplicatesCount}>{row.count - 1}</div>
}

const ActionsRowCell = ({
  row,
  store,
}: {
  row: RowContactDuplicate
  store: ContactsDuplicateTableStore
}) => {
  return (
    <Box
      sx={{
        alignItems: 'center',
        justifyContent: 'flex-end',
        height: '32px',
      }}
      gap={1}
      display='flex'
    >
      <Button
        size={'medium'}
        contained={'tertiary'}
        text={'Review'}
        onClick={() => {
          store.contactsMergeModalStore.init(
            store.list.map((row) => row.origin),
            row.id,
            store.dispose
          )
        }}
      />
    </Box>
  )
}

export const columns = (store: ContactsDuplicateTableStore): IColumn<RowContactDuplicate>[] => {
  return [
    {
      field: 'name',
      name: 'Name',
      fullName: 'Name',
      renderRowCell: (row) => <ContactRowCell row={row} />,
      maxWidth: 365,
    },
    {
      field: 'duplicates',
      name: 'Duplicates',
      renderRowCell: (row) => <DuplicateRowCell row={row} />,
    },
    {
      field: 'actions',
      name: ' ',
      renderRowCell: (row) => <ActionsRowCell row={row} store={store} />,
    },
  ]
}
